<template>
    <div>
        <el-dialog
            title="调查报告"
            :visible.sync="showpicker"
            width="800px"
            @close="back">
            <div class="warp">
                <p class="title">{{title}}</p>
                <div class="su-content">
                    <p class="text title">问卷调查结果:</p>
                    <div class="su-cell" v-for="(item, index) in surveys" :key="index">
                        <p class="text quest-title" v-if="index<surveys.length-1">{{index+1}}、{{item.title}}</p>
                        <p class="text quest-value" v-if="item.title">
                            <span class="t-text">是：{{item['是']}}</span>
                            <span class="t-text">否：{{item['否']}}</span>
                        </p>
                        <div class="idea-box" v-else>
                            <p class="text title">其他意见或建议</p>
                            <div class="idea-list" v-for="(idea, ind) in item" :key="ind">
                                <p class="text">{{ind+1}}、{{idea}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showpicker: true,
            title: '',
            surveys: '',
            total: 0,
        }
    },
    mounted () {
        var title = this.$route.query.title;
        this.title = title;
        if (this.title) {
            this.getdata();
        }
    },
    methods: {
        getdata() {
            var params = {
                title: this.title
            }
            this.$api.getsurveyreport(params).then(
                data=>{
                    let {list, total} = data;
                    this.surveys = list;
                    this.total = total;
                }
            )
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>
.title{
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
    text-align: center;
}
.su-content{
    margin-top: 20px;
    overflow: hidden;
    .text.title{
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        text-align: left;
        color:#555;
    }
    .su-cell{
        margin-bottom: 20px;
        overflow: hidden;
        .quest-value{
            text-indent: 1.4rem;
            color: #4773a0;
            .t-text{
                margin-right: 30px;
            }
        }
        .quest-text{
            text-indent: 1.4rem;
            color: #3a8ee6;
            text-decoration: underline;
        }
    }
    .idea-box{
        border-top: 1px solid #c0c4cc;
        margin-top: 20px;
        padding-top: 30px;
        position: relative;
        .text.title{
            display: inline-block;
            background: #fff;
            padding: 0 10px;
            line-height: 20px;
            margin-bottom: 0;
            position: absolute;
            top: -10px;
            left: 50%;
            width: 200px;
            text-align: center;
            transform: translateX(-100px);
        }
        .idea-list{
            margin-bottom: 10px;
        }
    }
}
</style>